<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="72.14"
    height="19.16"
    viewBox="0 0 72.14 19.16"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        y1="0.5"
        x2="1"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0.01" stop-color="#00a7e3" />
        <stop offset="0.337" stop-color="#009ddc" />
        <stop offset="0.875" stop-color="#0084c9" />
        <stop offset="1" stop-color="#007ec4" />
      </linearGradient>
    </defs>
    <g
      id="Сгруппировать_3120"
      data-name="Сгруппировать 3120"
      transform="translate(0 0)"
    >
      <path
        id="Контур_1141"
        data-name="Контур 1141"
        d="M172.26,112.689l-2.539,8.8h-.435l-2.539-8.8a3.485,3.485,0,0,0-3.347-2.518h-6.088v19.16h6.095V118.009h.436l3.483,11.322h4.354l3.483-11.322h.435v11.322h6.1v-19.16h-6.088a3.485,3.485,0,0,0-3.347,2.518"
        transform="translate(-157.312 -110.171)"
        fill="#20aa4d"
      />
      <path
        id="Контур_1140"
        data-name="Контур 1140"
        d="M281.468,112.2l-4.291,9.3h-.436V110.173h-6.1v19.158h5.175a3.483,3.483,0,0,0,3.162-2.024l4.292-9.3h.435v11.321h6.1V110.173h-5.173a3.483,3.483,0,0,0-3.163,2.024"
        transform="translate(-241.211 -110.173)"
        fill="#20aa4d"
      />
      <path
        id="Контур_1142"
        data-name="Контур 1142"
        d="M362.05,146.734v10.451h6.083v-6.1h6.544a6.529,6.529,0,0,0,6.152-4.355Z"
        transform="translate(-308.906 -138.024)"
        fill="#20aa4d"
      />
      <path
        id="Контур_1143"
        data-name="Контур 1143"
        d="M371.891,110.173h-13.5a9.579,9.579,0,0,0,9.417,7.838h10.483a6.632,6.632,0,0,0,.131-1.306,6.532,6.532,0,0,0-6.531-6.531"
        transform="translate(-306.282 -110.173)"
        fill="url(#linear-gradient)"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Icon',
  }
</script>
